import { render, staticRenderFns } from "./taskListItemCompact.vue?vue&type=template&id=66474f36&"
import script from "./taskListItemCompact.vue?vue&type=script&lang=js&"
export * from "./taskListItemCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports